import { APP_INITIALIZER, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import localeRu from '@angular/common/locales/ru';
import localeUk from '@angular/common/locales/uk';
import { registerLocaleData } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { StoreModule } from './store/store.module';
import { SharedModule } from './shared/shared.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { OrderModule } from './modules/order/order.module';
import { AdminModule } from './modules/admin/admin.module';
import { ProblemModule } from './modules/problem/problem.module';
import { SelfDiagnosticModule } from './modules/self-diagnostic/self-diagnostic.module';
import { LoginModule } from './modules/login/login.module';
import { AuthHttpInterceptor, AuthService } from './core/services/auth-service';
import { firstValueFrom } from 'rxjs';

registerLocaleData(localeRu);
registerLocaleData(localeUk);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  exports: [],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    StoreModule,
    CoreModule,
    SharedModule,
    DashboardModule,
    OrderModule,
    AdminModule,
    ProblemModule,
    SelfDiagnosticModule,
    LoginModule,
  ],
  providers: [
    AuthService,
    provideHttpClient(withInterceptors([AuthHttpInterceptor])),
    provideAppInitializer(async () => {
      const authService = inject(AuthService);
      await firstValueFrom(authService.init());
    }),
    Title,
  ],
})
export class AppModule {}
